import { graphql, useStaticQuery } from "gatsby";
import React from 'react';
import { isMobile } from "react-device-detect";
import styled from 'styled-components';

const Homebanner = styled.div`
  width: 100%;
  background-color: #f1f1f1;
  padding: 0.5rem 0;
  text-align: center;
  font-style: normal;
  font-size: 15px;
  line-height: 100%;
  text-align: center;
  letter-spacing: 0.72px;
  font-weight: 500;
  position: fixed;
  top: 0;
  z-index: 99;

  & + .hideTopBanner.scrolled-false .topbannerCont{
    top: 2rem !important;
  }
  & + .hideTopBanner.scrolled-true .topbannerCont{
    top: 0 !important;
  }
  & ~ .header {
    top: 24px !important;
    transition: all 0.3s ease 0s, transform 0.5s ease 0s;
  }
  & + .belowThreeDesktop {
    top: -4px !important;
  }
  & + .belowThreeMobile.scrolled-false  {
    margin-top: 35px;
  }
  & + .belowThreeMobile.scrolled-true  {
    margin-top: 0;
  }
  & + .belowThreeMobile.scrolled-false ~ .sidebar  {
    top: 110px !important;
  }
  & + .hideTopBanner.scrolled-false ~ .sidebar {
    top: 110px !important;
  }
  & p {
    padding: 0;
    margin: 0;
  }
  & a {
    text-decoration: underline !important;
  }

  ${isMobile && `
    & + header.belowThreeMobile.scrolled-true {
      top: 0 !important;
    }
  `}
`;

const HomepageAlertBanner = () => {
    const data = useStaticQuery(graphql`
          query {
            allNygaV1Homebanners {
              nodes {
                data {
                  id
                  title
                  priority
                  content
                  active
                }
              }
            }
          }
    `);
    
    const homebanners = data.allNygaV1Homebanners?.nodes[0].data.sort((a,b) => a.priority - b.priority);
    return (
        <>
            {homebanners && homebanners.length > 0 && (
                homebanners.slice(0,1).map(banner => (
                    <Homebanner className="alertBanner" key={banner.id} dangerouslySetInnerHTML={{__html: banner.content}}/>
                ))
            )}
        </>
    );
};
  
export default HomepageAlertBanner;